import React from 'react';
import { LFC } from '../../../Legacy';
import { JiraProjectData } from '../../../api/endpoints/jira';
import { Icon } from '../../../concepts/resources/Icon';
import { usePrompt } from '../../../ui';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../../popups/Popup';
import { SelectJiraProjectView } from './SelectJiraProjectView';

export const selectJiraProjectPopup = () => ({ ui: SelectJiraProjectPopup });

export const SelectJiraProjectPopup: LFC<PopupProps> = ({ action, dismiss, args }) => {

    const promptRef = usePrompt({
        ignoreEnter: true,
        onAction: dismiss,
    });

    const onSelectProject = (project: JiraProjectData) => {
        action(project);
    };

    return <Popup ref={promptRef} p="1">
        <Popup.Header>
            <Popup.IconFrame>
                <Icon src="deqo://icons/i8/color-jira" size="2" />
            </Popup.IconFrame>
            <Popup.Title>
                Select Jira Project
            </Popup.Title>
            <Popup.SubTitle>
                Please select the project you want to do something with.
            </Popup.SubTitle>
        </Popup.Header>
        <br />
        <Popup.Content>
            <Flexer flex="column" width="48" height="36">
                <SelectJiraProjectView onSelect={onSelectProject} />
            </Flexer>
        </Popup.Content>
        <Popup.Close onAction={dismiss} />
    </Popup>;
};
